import {LayerImagery, LayerLoadType, MapperViewer} from '../../types';

export class ZmiSEMLayer implements LayerImagery {

  id = 'zi_dn_senegal';
  name = 'ZM inondation';
  active = true;
  imageryLayer = new Cesium.ImageryLayer(new Cesium.WebMapServiceImageryProvider({
    url: 'https://mapserver-v2.predictservices.ws/wms?', // URL du service WMS
    layers: 'zone_inondable_senegal_wms',    // Nom de la couche WMS à afficher
    parameters: {
      service: 'WMS',
      version: '1.3.0',
      request: 'GetMap',
      styles: '',                // Style à utiliser (si applicable)
      format: 'image/png',       // Format de l'image (exemple : PNG)
      transparent: true,
      width: 512,
      height: 512
    },
    tilingScheme: new Cesium.GeographicTilingScheme(),
    maximumLevel: 18,
  }));
  loadType: LayerLoadType;
  viewer: MapperViewer;
  showLabel = false;

  /* Custom properties */
  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.imageryLayers.add(this.imageryLayer);
  }

  remove(): void {
    this.viewer.imageryLayers.remove(this.imageryLayer, false);
  }

  loadData(): void {
  }

  setActive(active: boolean): void {
    this.active = active;
    this.imageryLayer.show = active;
  }

  onAfterPrint(): void {
  }

  onBeforePrint(): void {
  }
}
